var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { DOT_TYPE, g_plateDefinitions, isPlatePaper, isPUI, makeNPageIdStr, PU_TO_NU } from "../common";
import { IBrushType, PenEventName, PEN_STATE } from "../common/enums";
import { EventDispatcher } from "../common/event";
import { NEO_SMARTPEN_TYPE } from "../common/neopen/INeoSmartpen";
import { InkStorage } from "../common/penstorage";
import PUIController from "../common/pui/PUIController";
// import PUIController from "../../components/PUIController";
import { NeoDot, StrokePageAttr } from "../common/structures";
import { logTimeStamp } from "./pencomm/pen_util_func";
import { _defaultMaxPenPressureValue } from "./PenConstants";
import PenManager, { DEFAULT_PEN_THICKNESS } from "./PenManager";
export default class SmartPenBase {
    /**
     * Creates an instance of SmartPenBase.
     * @param {InkStorage} customStorage
     * @param {string} networkId
     * @param {string} mac
     * @memberof SmartPenBase
     */
    constructor(customStorage, networkId, mac) {
        /**
         * npm install -D @types/web-bluetooth
         *
         * @return {*}  {BluetoothDevice}
         * @memberof SmartPenBase
         */
        this.getBtDevice = () => {
            throw new Error("getBtDevice() not implemented");
        };
        this.getMac = () => {
            throw new Error("getMac() not implemented");
        };
        /**
         *
         *
         * @return {*}  {Promise<boolean>}
         * @memberof SmartPenBase
         */
        this.connect = (requestOnlineDataOnConencted = true) => __awaiter(this, void 0, void 0, function* () {
            throw new Error("connect() not implemented");
        });
        /**
         *
         *
         * @param {BluetoothDevice} device
         * @return {*}  {Promise<boolean>}
         * @memberof SmartPenBase
         */
        this.connectByWebBtDevice = (device) => __awaiter(this, void 0, void 0, function* () {
            throw new Error("connectByWebBtDevice() not implemented");
        });
        /**
         *
         *
         * @param {string} mac
         * @return {*}  {Promise<boolean>}
         * @memberof SmartPenBase
         */
        this.connectByMacAddress = (mac) => __awaiter(this, void 0, void 0, function* () {
            throw new Error(`connectByMacAddress() not implemented yet.`);
        });
        /**
         *
         *
         * @memberof SmartPenBase
         */
        this.disconnect = () => {
            throw new Error(`disconnect() not implemented yet.`);
        };
        /**
         * DO NOT USE with remote pen, 2021/08/18
         * because this function will set stroke.originalKey
         *
         * @private
         * @param {{
         *       timeStamp: number,
         *       penTipMode: number,
         *     }} event
         * @returns {*}
         * @memberof SmartPenBase
         */
        this.processPenDown = (event) => {
            // pen down 처리
            const mac = this.mac;
            const time = event.timeStamp;
            // TODO: uuid 로직 변경 NULL_UUID
            // const uuid = uuidv4(); // TODO: 신규 생성되는 스트로크의 UUID, 이것 수정할 것, 2022/04/06
            const openStrokeArg = {
                // uuid,
                mac,
                time,
                penTipMode: event.penTipMode,
                brushType: this.penRendererType,
                thickness: this.penState[this.penRendererType].thickness,
                color: this.penState[this.penRendererType].color,
                inputType: this.inputType,
                writerId: this.writerId,
                surfaceOwnerId: this.surfaceOwnerId,
                // 2021/06/20
                originalKey: null,
            };
            const stroke = this.storage.openStroke(openStrokeArg);
            const strokeKey = stroke.key;
            // 2021/08/18
            stroke.originalKey = strokeKey;
            this.currPenMovement.stroke = stroke;
            return { strokeKey, mac, time, stroke };
        };
        /**
         *
         *
         * @param {{
         *       mac: string,
         *       timeStamp: number,
         *       penTipMode: number,
         *     }} event
         * @memberof SmartPenBase
         */
        this.onPenDown = (event) => {
            this.resetPenStroke();
            this.currPenMovement.downEvent = event;
            this.lastState = PEN_STATE.PEN_DOWN;
            const penDownStrokeInfo = this.processPenDown(event);
            logTimeStamp(event.timeStamp);
            this.dispatcher.dispatch(PenEventName.ON_PEN_DOWN, {
                // ...penDownStrokeInfo,
                strokeKey: penDownStrokeInfo.strokeKey,
                mac: penDownStrokeInfo.mac,
                time: penDownStrokeInfo.time,
                stroke: penDownStrokeInfo.stroke,
                pen: this,
                inputType: this.inputType,
            });
            this.manager.setActivePen(event.mac);
        };
        /**
         * 펜의 움직임
         *    1) down/up이 있는 경우: DOWN -> INFO -> MOVE -> MOVE -> ... -> UP -> INFO와 같이 나옴
         *    2) hove의 경우: (페이지가 바뀌면) INFO -> HOVER_MOVE -> HOVER_MOVE...
         *
         * pen down 된 후의 page info, 실질적으로 pen_down과 같음
         *
         * @param {{
         *       section: number, owner: number, book: number, page: number,
         *       timeStamp: number,
         *       physicalSobp?: IPageSOBP,
         *     }} event
         * @param {boolean} hover
         * @returns {*}
         * @memberof SmartPenBase
         */
        this.onPageInfo = (event, hover) => {
            event.physicalSobp = { section: event.section, owner: event.owner, book: event.book, page: event.page };
            /**
             * Plate에서 들어오는 펜 입력의 입력 페이지는 현재 renderer page를 그대로 가져온다
             * 활성화된 renderer page가 없으면 cancel 하도록 할까?
             */
            if (isPlatePaper(event.physicalSobp)) {
                // console.log(`plate sobp = ${makeNPageIdStr(event.physicalSobp)}`)
                if (this.currentPageSizePuFn) {
                    const { sobp } = this.currentPageSizePuFn();
                    event.section = sobp.section;
                    event.owner = sobp.owner;
                    event.book = sobp.book;
                    event.page = sobp.page;
                }
                else {
                    // TODO: 단순히 cancel 한다, 다른 방법이 없을까?
                    event.section = -1;
                    event.owner = -1;
                    event.book = -1;
                    event.page = -1;
                    this.currPenMovement.infoEvent = event;
                    return;
                }
            }
            // TODO: pui라고 하면, 스트로크 타입을 PUI로 변경하고 추가할 것
            // 추가되고 나면, close에서 스트로크의 PUI 이벤트를 발생 시킬 것
            if (isPUI(Object.assign(Object.assign({}, event.physicalSobp), { x: 0, y: 0 })) && (!hover)) {
                this.currPenMovement.infoEvent = event;
                const stroke = this.currPenMovement.stroke;
                stroke.set({ brushType: IBrushType.PUI });
                const { section, owner, book, page, timeStamp } = event;
                const strokeKey = stroke.key;
                this.storage.setStrokeInfo(strokeKey, section, owner, book, page, timeStamp);
                return;
            }
            // 이전에 펜 down이 있었으면
            if (this.lastState === PEN_STATE.PEN_DOWN) {
                this.currPenMovement.infoEvent = event;
                if (this.manager.isCalibrationMode) {
                    return;
                }
                const { section, owner, book, page, timeStamp } = event;
                const mac = this.mac;
                if (!mac) {
                    throw new Error("onPageInfo mac address was not registered");
                }
                if (!hover) {
                    // storage에 저장
                    const stroke = this.currPenMovement.stroke;
                    const strokeKey = stroke.key;
                    this.storage.setStrokeInfo(strokeKey, section, owner, book, page, timeStamp);
                    // hand pen page the event
                    this.dispatcher.dispatch(PenEventName.ON_PEN_PAGEINFO, { strokeKey, mac, stroke, section, owner, book, page, time: event.timeStamp });
                }
                else {
                    // hand hover page the event
                    this.dispatcher.dispatch(PenEventName.ON_PEN_HOVER_PAGEINFO, { mac, section, owner, book, page, time: event.timeStamp });
                }
            }
            else if (this.lastState === PEN_STATE.PEN_MOVE) {
                this.currPenMovement.infoEvent = event;
                // 펜 move 중 페이지가 바뀌는 경우
                // 1) pen up 처리
                {
                    const stroke = this.currPenMovement.stroke;
                    stroke.set({ multiPage: StrokePageAttr.MULTIPAGE });
                    const penUpStrokeInfo = this.processPenUp(event);
                    const { mac, section, owner, book, page } = penUpStrokeInfo.stroke;
                    console.log(`NeoSmartpen dispatch event VIRTUAL ON_PEN_UP`);
                    this.dispatcher.dispatch(PenEventName.ON_PEN_UP_VIRTUAL, {
                        stroke: penUpStrokeInfo.stroke,
                        strokeKey: penUpStrokeInfo.strokeKey,
                        mac, pen: this, inputType: this.inputType,
                        section, owner, book, page
                    });
                    this.resetPenStroke();
                }
                // 2) pen down처리
                {
                    const penDownStrokeInfo = this.processPenDown(event);
                    const stroke = penDownStrokeInfo.stroke;
                    stroke.set({ multiPage: StrokePageAttr.MULTIPAGE });
                    console.log(`NeoSmartpen dispatch event VIRTUAL ON_PEN_DOWN`);
                    this.dispatcher.dispatch(PenEventName.ON_PEN_DOWN_VIRTUAL, penDownStrokeInfo);
                }
                // 3) page Info 처리
                const { section, owner, book, page, timeStamp } = event;
                const mac = this.mac;
                if (!hover) {
                    // storage에 저장
                    const stroke = this.currPenMovement.stroke;
                    const strokeKey = stroke.key;
                    this.storage.setStrokeInfo(strokeKey, section, owner, book, page, timeStamp);
                    // hand pen page the event
                    this.dispatcher.dispatch(PenEventName.ON_PEN_PAGEINFO, { strokeKey, mac, stroke, section, owner, book, page, time: event.timeStamp });
                }
                else {
                    // hand hover page the event
                    this.dispatcher.dispatch(PenEventName.ON_PEN_HOVER_PAGEINFO, { mac, section, owner, book, page, time: event.timeStamp });
                }
            }
            if (hover) {
                const { section, owner, book, page, timeStamp } = event;
                const mac = this.mac;
                this.currPenMovement.infoEvent = event;
                if (this.manager.isCalibrationMode) {
                    return;
                }
                this.dispatcher.dispatch(PenEventName.ON_PEN_HOVER_PAGEINFO, {
                    inputType: this.inputType,
                    mac,
                    section,
                    owner,
                    book,
                    page,
                    time: timeStamp,
                    pen: this
                });
            }
            return;
        };
        /**
         * pen down 상태에서 움직임
         *
         * @param {{
         *       x: number,
         *       y: number,
         *       force: number,
         *       timeStamp: number,
         *       timediff: number,
         *     }} originalEvent
         * @returns {*}
         * @memberof SmartPenBase
         */
        this.onPenMove = (event) => {
            var _a;
            // let event = originalEvent as IPenCommEvent;
            this.lastState = PEN_STATE.PEN_MOVE;
            // 기존의 방식에서는 처리하지 않았던 것, redundant할 수 있다.
            if (this.currPenMovement.infoEvent) {
                event.section = this.currPenMovement.infoEvent.section;
                event.owner = this.currPenMovement.infoEvent.owner;
                event.book = this.currPenMovement.infoEvent.book;
                event.page = this.currPenMovement.infoEvent.page;
            }
            else {
                /**
                 * 종이에 터치되지 않고 들어오는 호버 이벤트
                 *
                 */
                event.section = -1;
                event.owner = -1;
                event.book = -1;
                event.page = -1;
                return;
            }
            // console.log(`${event.section}.${event.owner}.${event.book}.${event.page}`);
            let force = event.force;
            if (force > 1)
                force /= this.maxPenPressureValue;
            if (this.manager.isCalibrationMode) {
                this.manager.calibrationData.points.push({
                    x: event.x,
                    y: event.y,
                    f: force,
                });
                return;
            }
            this.currPenMovement.numMovement++;
            event.isFirstDot = (this.currPenMovement.numMovement === 1);
            // 2021/06/30, Plate 처리
            const sobp = (_a = this.currPenMovement.infoEvent) === null || _a === void 0 ? void 0 : _a.physicalSobp;
            if (sobp && isPlatePaper(sobp)) {
                // 2021/08/04, network pen이면서, plate이면 move 자체를 처리하지 않는다.
                if (event.fromNetworkPen)
                    return;
                event = this.convertPlateXyToPage(event, sobp);
                if (!event)
                    return;
            }
            const dot = new NeoDot({
                dotType: DOT_TYPE.penmove,
                deltaTime: event.timediff,
                time: event.timeStamp,
                f: force,
                x: event.x,
                y: event.y,
            });
            logTimeStamp(event.timeStamp + event.timediff);
            const stroke = this.currPenMovement.stroke;
            const strokeKey = stroke.key;
            this.storage.appendDot(strokeKey, dot);
            // 2021/07/03 PUI
            if (sobp && isPUI(Object.assign(Object.assign({}, sobp), { x: event.x, y: event.y }))) {
                return;
            }
            // hand the event
            const pen = this;
            this.dispatcher.dispatch(PenEventName.ON_PEN_MOVE, {
                inputType: this.inputType,
                strokeKey, mac: stroke.mac, stroke, dot, pen, event: event
            });
        };
        /**
         * hover 상태에서 움직임
         *
         * @param {{
         *       x: number
         *       y: number,
         *     }} originalEvent
         * @returns {*}
         * @memberof SmartPenBase
         */
        this.onHoverMove = (event) => {
            var _a;
            this.lastState = PEN_STATE.HOVER_MOVE;
            if (this.manager.isCalibrationMode) {
                return;
            }
            // 기존의 방식에서는 처리하지 않았던 것, redundant할 수 있다.
            if (this.currPenMovement.infoEvent) {
                event.section = this.currPenMovement.infoEvent.section;
                event.owner = this.currPenMovement.infoEvent.owner;
                event.book = this.currPenMovement.infoEvent.book;
                event.page = this.currPenMovement.infoEvent.page;
            }
            else {
                /**
                 * 종이에 터치되지 않고 들어오는 호버 이벤트
                 *
                 */
                event.section = -1;
                event.owner = -1;
                event.book = -1;
                event.page = -1;
                return;
            }
            // 2021/06/30, Plate 처리
            const sobp = (_a = this.currPenMovement.infoEvent) === null || _a === void 0 ? void 0 : _a.physicalSobp;
            if (sobp && isPlatePaper(sobp)) {
                // 2021/08/04, network pen이면서, plate이면 move 자체를 처리하지 않는다.
                if (event.fromNetworkPen)
                    return;
                event = this.convertPlateXyToPage(event, sobp);
                if (!event)
                    return;
            }
            // 2021/07/03 PUI
            if (sobp && isPUI(Object.assign(Object.assign({}, sobp), { x: event.x, y: event.y }))) {
                return;
            }
            const mac = this.mac;
            if (!mac) {
                throw new Error("onHoverMove mac address was not registered");
            }
            this.dispatcher.dispatch(PenEventName.ON_HOVER_MOVE, {
                inputType: this.inputType,
                pen: this, mac, event: event
            });
        };
        /**
         * hover 상태에서 페이지 바뀜
         *
         * @param {IPenCommEvent} event
         * @return {*}
         * @memberof SmartPenBase
         */
        this.onHoverPageInfo = (event) => {
            this.lastState = PEN_STATE.HOVER_MOVE;
            if (this.manager.isCalibrationMode) {
                return;
            }
            const mac = this.mac;
            if (!mac) {
                throw new Error("onHoverPageInfo mac address was not registered");
            }
            // 2021/08/04, network pen이면서, plate이면 move 자체를 처리하지 않는다.
            if (!event.fromNetworkPen) {
                this.dispatcher.dispatch(PenEventName.ON_PEN_HOVER_PAGEINFO, {
                    inputType: this.inputType,
                    pen: this, mac, event: event
                });
            }
        };
        this.processPenUp = (event) => {
            const stroke = this.currPenMovement.stroke;
            const strokeKey = stroke.key;
            // 2021/08/04, network pen이면서, plate이면 처리하지 않는다.
            this.storage.closeStroke(strokeKey);
            return { strokeKey, stroke };
        };
        /**
         *
         *
         * @param {IPenCommEvent} event
         * @memberof SmartPenBase
         */
        this.onPenUp = (event) => {
            this.lastState = PEN_STATE.PEN_UP;
            this.currPenMovement.upEvent = event;
            logTimeStamp(event.timeStamp);
            // calibration 모드이면
            if (this.manager.isCalibrationMode) {
                const penUpStrokeInfo = { strokeKey: null, stroke: null };
                const { section, owner, book, page } = this.currPenMovement.infoEvent;
                // 2021/08/04, network pen이면서, plate이면 처리하지 않는다.
                if (!event.fromNetworkPen) {
                    this.dispatcher.dispatch(PenEventName.ON_PEN_UP, {
                        stroke: penUpStrokeInfo.stroke,
                        strokeKey: penUpStrokeInfo.strokeKey,
                        inputType: this.inputType, mac: null, pen: this, section, owner, book, page
                    });
                }
                this.resetPenStroke();
                return;
            }
            // 그렇지 않으면 storage에 저장
            const penUpStrokeInfo = this.processPenUp(event);
            // 2021/08/04, network pen이면서, plate이면 처리하지 않는다.
            if (!event.fromNetworkPen) {
                if (penUpStrokeInfo.stroke.brushType === IBrushType.PUI) {
                    console.log(`PUI 처리 중`);
                    const pui = PUIController.getInstance();
                    pui.getStrokePuiCommand(penUpStrokeInfo.stroke).then(commands => {
                        if (commands.length > 0) {
                            console.log(`PUI Command: ${commands}`);
                            // command가 실행되었으면
                            commands.forEach((cmd) => {
                                this.dispatcher.dispatch(PenEventName.ON_PUI_COMMAND, {
                                    inputType: this.inputType,
                                    puiCommand: cmd,
                                    pen: this,
                                    mac: this.mac,
                                    stroke: penUpStrokeInfo.stroke,
                                });
                            });
                        }
                    });
                }
                else {
                    const { mac, section, owner, book, page } = penUpStrokeInfo.stroke;
                    this.dispatcher.dispatch(PenEventName.ON_PEN_UP, {
                        stroke: penUpStrokeInfo.stroke,
                        strokeKey: penUpStrokeInfo.strokeKey,
                        inputType: this.inputType, mac, pen: this, section, owner, book, page
                    });
                }
            }
            this.resetPenStroke();
        };
        /**
         *
         *
         * @param {IPenCommEvent} event
         * @memberof SmartPenBase
         */
        this.onNcodeError = (event) => {
            // console.log(event);
            // let ph = this.appPen;
            // ph.onNcodeError(event);
            const mac = this.mac;
            if (!mac) {
                throw new Error("onNcodeError mac address was not registered");
            }
            this.manager.onNcodeError({ pen: this, event });
            this.dispatcher.dispatch(PenEventName.ON_NCODE_ERROR, {
                inputType: this.inputType,
                pen: this, mac, event: event
            });
        };
        /**
         *
         *
         * @param {IPenCommEvent} event
         * @memberof SmartPenBase
         */
        this.onConnected = (event) => {
            throw new Error("onConnected is not implemented");
        };
        /**
         *
         *
         * @param {IPenCommEvent} event
         * @memberof SmartPenBase
         */
        this.onFirmwareUpgradeNeeded = (event) => {
            const mac = this.mac;
            this.dispatcher.dispatch(PenEventName.ON_UPGRADE_NEEDED, {
                inputType: this.inputType,
                pen: this,
                mac,
                event: event
            });
        };
        /**
         *
         *
         * @param {IPenCommEvent} event
         * @memberof SmartPenBase
         */
        this.onDisconnected = (event) => {
            this.connected = false;
            const mac = this.mac;
            if (!mac) {
                console.error(`onDisconnected mac address was not registered`);
                console.log(`mac address was not registered`);
                // console.log(event);
            }
            else {
                this.dispatcher.dispatch(PenEventName.ON_DISCONNECTED, {
                    inputType: this.inputType,
                    pen: this, mac, event: event
                });
            }
        };
        /**
         *
         *
         * @memberof SmartPenBase
         */
        this.resetPenStroke = () => {
            const p = this.currPenMovement;
            p.downEvent = null;
            p.infoEvent = null;
            p.numMovement = 0;
            p.moveEvents = [];
            p.upEvent = null;
        };
        /**
         *
         *
         * @param {string} color
         * @memberof SmartPenBase
         */
        this.setColor = (color) => {
            this.penState[this.penRendererType].color = color;
        };
        /**
         *
         *
         * @param {number} thickness
         * @memberof SmartPenBase
         */
        this.setThickness = (thickness) => {
            this.penState[this.penRendererType].thickness = thickness;
        };
        /**
         *
         *
         * @param {IBrushType} type
         * @memberof SmartPenBase
         */
        this.setPenRendererType = (type) => {
            this.penRendererType = type;
        };
        /**
         *
         *
         * @param {PenEventName} eventName
         * @param {(event: IPenToViewerEvent) => void} listener
         * @memberof SmartPenBase
         */
        this.addEventListener = (eventName, listener) => {
            if (eventName === PenEventName.ON_PEN_DOWN) {
                console.log(`NeoSmartpen: addEventListener ${eventName}`);
            }
            this.dispatcher.on(eventName, listener, null);
        };
        /**
         *
         *
         * @param {PenEventName} eventName
         * @param {(event: IPenToViewerEvent) => void} listener
         * @memberof SmartPenBase
         */
        this.removeEventListener = (eventName, listener) => {
            this.dispatcher.off(eventName, listener);
        };
        this.setSurfaceOwnerId = (ownerId) => {
            this.surfaceOwnerId = ownerId;
            this.dispatcher.dispatch(PenEventName.ON_SURFACE_OWNER_CHANGED, {
                mac: this.getMac(),
                pen: this,
                inputType: this.inputType,
                surfaceOwnerId: ownerId,
            });
        };
        this.setWriterId = (writerId) => {
            this.writerId = writerId;
            if (!this.surfaceOwnerId) {
                this.surfaceOwnerId = writerId;
            }
            this.dispatcher.dispatch(PenEventName.ON_WRITER_CHANGED, {
                mac: this.getMac(),
                pen: this,
                inputType: this.inputType,
                writerId: writerId,
            });
        };
        this.removeEventListenerAll = () => {
            this.dispatcher.offAll();
        };
        this.getStorage = () => {
            return this.storage;
        };
        /** Renderer가 세팅할 현재 페이지의 사이즈 */
        this.currentPageSizePuFn = undefined;
        this.setPageSizeRetreiveFn = (fn, enable) => {
            if (enable) {
                this.currentPageSizePuFn = fn;
            }
            else {
                // viewer 자신이 설정한 것만 disable 가능하게 한다
                if (this.currentPageSizePuFn === fn) {
                    this.currentPageSizePuFn = undefined;
                }
            }
        };
        this.removetPageSizeRetreiveFn = () => {
            delete this.currentPageSizePuFn;
            this.currentPageSizePuFn = undefined;
        };
        /**
         *
         *
         * @private
         * @param {IPenCommEvent} event
         * @param {IPageSOBP} sobp
         * @returns {*}  {IPenCommEvent}
         * @memberof SmartPenBase
         */
        // private convertPlateXyToPage = (event: IPenCommEvent, sobp: IPageSOBP): IPenCommEvent => {
        //   const definition = g_plateDefinitions[makeNPageIdStr({ section: sobp.section, owner: sobp.owner, book: sobp.book, page: undefined })];
        //   if (!definition) return null;
        //
        //   // 좌표 변환을 위해 활성화된 렌더러가 없으면, 이벤트를 삭제하도록 null을 리턴한다
        //   if (!this.currentPageSizePuFn) return null;
        //
        //   const pageSize_pu = this.currentPageSizePuFn();
        //   const pageSize_nu = { width: pageSize_pu.width_pu * PU_TO_NU, height: pageSize_pu.height_pu * PU_TO_NU };
        //
        //   const { Xmin, Ymin, Xmax, Ymax } = definition.margin;
        //   const plateSize_nu = { width: Xmax - Xmin, height: Ymax - Ymin };
        //   const scale_x = pageSize_nu.width / plateSize_nu.width;
        //   const scale_y = pageSize_nu.height / plateSize_nu.height;
        //   const scale = Math.max(scale_x, scale_y);
        //
        //   event.x -= Xmin;
        //   event.y -= Ymin;
        //   event.x *= scale;
        //   event.y *= scale;
        //
        //   const nu_offset = {
        //     x: (plateSize_nu.width * scale - pageSize_nu.width) / 2,
        //     y: (plateSize_nu.height * scale - pageSize_nu.height) / 2
        //   }
        //   event.x -= nu_offset.x;
        //   event.y -= nu_offset.y;
        //
        //   return event;
        // }
        this.convertPlateXyToPage = (event, sobp) => {
            const definition = g_plateDefinitions[makeNPageIdStr({ section: sobp.section, owner: sobp.owner, book: sobp.book, page: undefined })];
            if (!definition)
                return null;
            // 좌표 변환을 위해 활성화된 렌더러가 없으면, 이벤트를 삭제하도록 null을 리턴한다
            if (!this.currentPageSizePuFn)
                return null;
            const pageSize_pu = this.currentPageSizePuFn();
            const pageSize_nu = { width: pageSize_pu.width_pu * PU_TO_NU, height: pageSize_pu.height_pu * PU_TO_NU };
            const { Xmin, Ymin, Xmax, Ymax } = definition.margin;
            let npaperWidth = Xmax - Xmin;
            let npaperHeight = Ymax - Ymin;
            let plateMode;
            if (npaperWidth > npaperHeight) {
                plateMode = "landscape";
            }
            else {
                plateMode = "portrait";
            }
            const currentPage = pageSize_nu;
            //currentPage는 앱에서 불러온 pdf의 page 입니다.
            let pageMode = ""; //page 기본값의 모드
            if (currentPage.width > currentPage.height) {
                pageMode = "landscape";
            }
            else {
                pageMode = "portrait";
            }
            let addedRotation = 0;
            if (plateMode === pageMode) {
                //둘다 같은 모드면 각도 조절이 필요 없음
                addedRotation = 0;
            }
            else {
                addedRotation = 90;
            }
            const finalRotation = (addedRotation) % 360;
            const { x, y } = event;
            //좌표 변환 먼저
            let newX = Math.cos(Math.PI / 180 * finalRotation) * x - Math.sin(Math.PI / 180 * finalRotation) * y;
            let newY = Math.sin(Math.PI / 180 * finalRotation) * x + Math.cos(Math.PI / 180 * finalRotation) * y;
            if (finalRotation === 90) {
                newX += Ymax;
            }
            else if (finalRotation === 180) {
                newX += Xmax;
                newY += Ymax;
            }
            else if (finalRotation === 270) {
                newY += Xmax;
            }
            const pageWidth = currentPage.width;
            const pageHeight = currentPage.height;
            if (finalRotation === 90 || finalRotation === 270) {
                npaperHeight = Xmax - Xmin;
                npaperWidth = Ymax - Ymin;
            }
            const wRatio = pageWidth / npaperWidth;
            const hRatio = pageHeight / npaperHeight;
            let platePdfRatio = wRatio;
            if (hRatio > wRatio)
                platePdfRatio = hRatio;
            const pdf_x = newX * platePdfRatio;
            const pdf_y = newY * platePdfRatio;
            event.x = pdf_x;
            event.y = pdf_y;
            return event;
        };
        /**
         * Pen의 호버 모드를 ON/OFF
         * @param on
         */
        this.setHoverMode = (on) => {
            throw new Error("not implemented");
        };
        /**
         * 펜 마다의 최대 필압을 제공
         * TODO: 현재는 구현되어 있지 않아서, 1024로
         * 2021/08/17
         */
        this.getMaxPressure = () => {
            return this.maxPenPressureValue;
        };
        /**
         * 필압을 0.0 ~ 1.0 까지로
         * 2021/08/17
         */
        this.getNormalizedPressure = (intPressure) => {
            let floatPressure = intPressure / this.maxPenPressureValue;
            if (floatPressure > 1)
                floatPressure = 1;
            return floatPressure;
        };
        /**
         * 2021/08/18
         * @param event
         */
        this.onPenStatusResponse = (event) => {
            throw new Error("onPenStatusResponse is not implemented");
        };
        /**
         *
         * @param event
         * @returns
         */
        this.onPasscodeRequired = (event) => {
            // const passcodeStatus = event.passcodeStatus;
            // const passcode = prompt("please enter passcode " + (9 - passcodeStatus.retryCount));
            // if (!passcode) return;
            // this.protocolHandler.sendPasscode(passcode);
            var _a;
            const mac = (_a = this.protocolHandler) === null || _a === void 0 ? void 0 : _a.getMac();
            if (!mac) {
                throw new Error("mac address was not given before");
            }
            this.dispatcher.dispatch(PenEventName.ON_PW_REQUIRED, {
                inputType: this.inputType,
                pen: this, mac, event: event
            });
        };
        /**
         * 2021/08/18
         * TODO: passcode를 넣으면 어떻게 동작하는지를 한번 더 살펴 봐야 한다
         * @param passcode
         */
        this.sendPasscode = (passcode) => {
            if (this.protocolHandler) {
                this.protocolHandler.sendPasscode(passcode);
            }
        };
        // 2022/05/17
        this.onFinishedOfflineDownload = (event) => {
            throw new Error("onFinishedOfflineDownload() is not implemented");
        };
        this.onStartOfflineDownload = (event) => {
            throw new Error("onStartOfflineDownload() is not implemented");
        };
        this.onOfflineDataDelivered = (event) => {
            throw new Error("onOfflineDataDelivered() is not implemented");
        };
        this.onOfflineDataListDelivered = (event) => {
            throw new Error("onOfflineDataListDelivered() is not implemented");
        };
        this.onPasswordChanged = (event) => {
            console.log(`onPasswordChanged`, event);
        };
        this.onShutdownEvent = (event) => {
            console.log(`onShutdownEvent`, event);
        };
        this.onLowBatteryEvent = (event) => {
            console.log(`onLowBatteryEvent`, event);
        };
        this.requestOfflineDataList = (section, owner, book) => {
            throw new Error("requestOfflineDataList() is not implemented");
        };
        this.reqOfflineData = (s, o, b, pgs = null, deleteOnFinished = true) => {
            throw new Error("reqOfflineData() is not implemented");
        };
        this.inputType = NEO_SMARTPEN_TYPE.REAL_PEN;
        this.protocolHandler = null;
        this.surfaceOwnerId = null;
        this.writerId = null;
        this.currPenMovement = {
            downEvent: null,
            infoEvent: null,
            moveEvents: [],
            upEvent: null,
            numMovement: 0,
            stroke: null,
        };
        // 2021/08/18
        this.maxPenPressureValue = _defaultMaxPenPressureValue;
        /** 펜 종류 마다의 굵기와 색깔 */
        this.penState = new Array(Object.keys(IBrushType).length);
        /** 펜 종류 (렌더러 종류) */
        this.penRendererType = IBrushType.PEN;
        this.mac = mac;
        this.webBluetoothId = null;
        this.lastState = PEN_STATE.NONE;
        // this.storage = InkStorage.getInstance();
        this.manager = PenManager.getInstance();
        this.dispatcher = new EventDispatcher();
        this.connected = false;
        if (customStorage) {
            console.log("use custom Ink Storage");
            this.storage = customStorage;
        }
        else {
            console.log("use default Ink Storage");
            this.storage = InkStorage.getInstance();
        }
        const color = this.manager.color;
        for (let i = 0; i < this.penState.length; i++) {
            this.penState[i] = {
                thickness: DEFAULT_PEN_THICKNESS / 10,
                color: color,
            };
        }
        // 2021/06/20
        this.overrideRemoteBrushType = false;
    }
}
//# sourceMappingURL=SmartPenBase.js.map